(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-native-reviews]').forEach((section) => {
  const toggle = section.querySelector('[data-review-form-toggle]');
  const form = section.querySelector('[data-review-form]');
  if (toggle && form) {
    toggle.addEventListener('click', () => {
      const open = form.hasAttribute('hidden');
      form.toggleAttribute('hidden', !open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) form.querySelector('input:not([type="hidden"])')?.focus();
    });
  }

  const photoInput = section.querySelector('[data-review-photo-input]');
  const photoPreview = section.querySelector('[data-review-photo-preview]');
  if (photoInput && photoPreview) {
    photoInput.addEventListener('change', () => {
      const file = photoInput.files?.[0];
      if (!file) {
        photoPreview.hidden = true;
        photoPreview.removeAttribute('src');
        return;
      }
      photoPreview.src = URL.createObjectURL(file);
      photoPreview.hidden = false;
    });
  }

  const list = section.querySelector('[data-review-list]');
  const pagination = section.querySelector('[data-review-pagination]');
  const cards = Array.from(section.querySelectorAll('[data-review-card]')).sort((a, b) => {
    const photoDifference = Number(b.dataset.hasPhoto) - Number(a.dataset.hasPhoto);
    if (photoDifference !== 0) return photoDifference;
    return Number(b.dataset.rating) - Number(a.dataset.rating);
  });
  cards.forEach((card) => list?.appendChild(card));
  const pageSize = 6;
  const totalPages = Math.ceil(cards.length / pageSize);
  let currentPage = 1;

  const showPage = (page, shouldScroll = false) => {
    currentPage = Math.min(Math.max(page, 1), totalPages);
    cards.forEach((card, index) => {
      card.hidden = index < (currentPage - 1) * pageSize || index >= currentPage * pageSize;
    });

    if (pagination) {
      pagination.replaceChildren();
      const addButton = (label, pageNumber, disabled = false, current = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.disabled = disabled;
        button.setAttribute('aria-label', label === '‹' ? 'Página anterior' : label === '›' ? 'Página siguiente' : `Página ${label}`);
        if (current) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => showPage(pageNumber, true));
        pagination.appendChild(button);
      };

      addButton('‹', currentPage - 1, currentPage === 1);
      for (let page = 1; page <= totalPages; page += 1) addButton(String(page), page, false, page === currentPage);
      addButton('›', currentPage + 1, currentPage === totalPages);
    }

    if (shouldScroll && list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (cards.length > 0) showPage(1);
});

  } catch(e) { console.error(e); }
})();
})();
